import { z } from 'zod';

/**
 * Mural do grupo de cada padrinho (GS12, parte B): o padrinho e os seus
 * afilhados escrevem e comentam, sem chat em tempo real. O Stream Staff ve
 * todos os murais e pode apagar.
 */

const datetimeSchema = z.string().datetime({ offset: true });

/** Quem escreveu, para o mural mostrar "padrinho" ou "Stream Staff" ao lado do login. */
export const wallRoleSchema = z.enum(['padrinho', 'streamer', 'staff']);
export type WallRole = z.infer<typeof wallRoleSchema>;

export const wallCommentSchema = z.object({
  id: z.string().uuid(),
  author: z.string(),
  role: wallRoleSchema,
  body: z.string(),
  createdAt: datetimeSchema,
});
export type WallComment = z.infer<typeof wallCommentSchema>;

export const wallPostSchema = z.object({
  id: z.string().uuid(),
  author: z.string(),
  role: wallRoleSchema,
  body: z.string(),
  createdAt: datetimeSchema,
  comments: z.array(wallCommentSchema),
  /** Para o streamer: publicacao ou comentario novo desde a ultima vez que viu. */
  unread: z.boolean(),
});
export type WallPost = z.infer<typeof wallPostSchema>;

/** Um mural: de que padrinho e as ultimas publicacoes. */
export const wallSchema = z.object({
  padrinho: z.object({ accountId: z.string().uuid(), login: z.string() }),
  unread: z.number().int(),
  posts: z.array(wallPostSchema),
});
export type Wall = z.infer<typeof wallSchema>;

export const wallPostInputSchema = z.object({
  body: z.string().trim().min(1, 'escreve alguma coisa').max(2000),
});
export type WallPostInput = z.infer<typeof wallPostInputSchema>;

export const wallCommentInputSchema = z.object({
  body: z.string().trim().min(1, 'escreve alguma coisa').max(1000),
});
export type WallCommentInput = z.infer<typeof wallCommentInputSchema>;
